{
  "id": "hexFrame",
  "name": "Hex Frame",
  "builds": "product",
  "category": "fineGoods",
  "note": "Six corners at 30°. Trust the angle stops.",
  "skill": "polygonJoinery",
  "duration": 35,
  "offeredBy": "bench",
  "fastener": "nails",
  "value": 15,
  "widthIn": 24,
  "heightIn": 20.785,
  "slots": [
    {
      "id": "rail-0",
      "role": "rail",
      "part": {
        "widthIn": 1,
        "lengthIn": 12,
        "thicknessQ": 1,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -30
          },
          "right": {
            "kind": "mitered",
            "angle": 30
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 12,
      "yIn": 0.5,
      "angleDeg": 90,
      "zIn": 0
    },
    {
      "id": "rail-1",
      "role": "rail",
      "part": {
        "widthIn": 1,
        "lengthIn": 12,
        "thicknessQ": 1,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -30
          },
          "right": {
            "kind": "mitered",
            "angle": 30
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 20.567,
      "yIn": 5.446,
      "angleDeg": 150,
      "zIn": 0
    },
    {
      "id": "rail-2",
      "role": "rail",
      "part": {
        "widthIn": 1,
        "lengthIn": 12,
        "thicknessQ": 1,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -30
          },
          "right": {
            "kind": "mitered",
            "angle": 30
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 20.567,
      "yIn": 15.338,
      "angleDeg": 210,
      "zIn": 0
    },
    {
      "id": "rail-3",
      "role": "rail",
      "part": {
        "widthIn": 1,
        "lengthIn": 12,
        "thicknessQ": 1,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -30
          },
          "right": {
            "kind": "mitered",
            "angle": 30
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 12,
      "yIn": 20.285,
      "angleDeg": 270,
      "zIn": 0
    },
    {
      "id": "rail-4",
      "role": "rail",
      "part": {
        "widthIn": 1,
        "lengthIn": 12,
        "thicknessQ": 1,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -30
          },
          "right": {
            "kind": "mitered",
            "angle": 30
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 3.433,
      "yIn": 15.338,
      "angleDeg": 330,
      "zIn": 0
    },
    {
      "id": "rail-5",
      "role": "rail",
      "part": {
        "widthIn": 1,
        "lengthIn": 12,
        "thicknessQ": 1,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -30
          },
          "right": {
            "kind": "mitered",
            "angle": 30
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 3.433,
      "yIn": 5.446,
      "angleDeg": 390,
      "zIn": 0
    }
  ],
  "fasteners": [
    {
      "xIn": 17.711,
      "yIn": 0.5
    },
    {
      "xIn": 6.289,
      "yIn": 0.5
    },
    {
      "xIn": 23.423,
      "yIn": 10.392
    },
    {
      "xIn": 17.712,
      "yIn": 20.284
    },
    {
      "xIn": 6.289,
      "yIn": 20.285
    },
    {
      "xIn": 0.577,
      "yIn": 10.392
    }
  ]
}
